import { render } from "./Checklist.vue?vue&type=template&id=3e51e376"
import script from "./Checklist.vue?vue&type=script&lang=js"
export * from "./Checklist.vue?vue&type=script&lang=js"
script.render = render

export default script